import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'add-default-mapping-dialog',
  templateUrl: './add-default-mapping-dialog.component.html',
  styleUrls: ['./add-default-mapping-dialog.component.scss']
})
export class AddDefaultMappingDialogComponent implements OnInit {

  defaultValue: number;
  arrInnerAssetColumns = [];
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddDefaultMappingDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public arrDefaultMappingDetail: any,
    public dialog: MatDialog
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    console.log("arrDefaultMappingDetail===>" + JSON.stringify(this.arrDefaultMappingDetail));

    this.arrInnerAssetColumns = this.arrDefaultMappingDetail.arrInnerAssetColumns;
    this.defaultValue =  this.arrDefaultMappingDetail.defaultValue;
    
    console.log('this.defaultValue===>'+this.defaultValue);
  }


  onNoClick(): void {
    this.dialogRef.close();
   
  }
  onSave(): void {
    this.dialogRef.close({ defaultValue: this.defaultValue });
    alert("Default Value Saved")
  }

}
